import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import Home from "./Home";

//

class Project4 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  toggleExpand = () => {
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  };
  render() {
    const { expanded } = this.state;
    return (
      <div className="Project4">
        <>
          <div className="ButtonMenu">
            <Link to="../Home#about">
              <button className="Menu">&#60;About&#62;</button>
            </Link>
            <Link to="../Home#work">
              <button className="Menu">&#60;Work&#62;</button>
            </Link>
            <button>
              <Link to="../Home#contact" className="Menu">
                &#60;Contact&#62;
              </Link>
            </button>
          </div>
        </>
        <div id="workdescription"></div>

        <div className="workbody">
          <div id="workdescription">
            {" "}
            <h1>
              BETWEEN <br />
              <span className="h2description">
                {" "}
                Introduction
                <br />
              </span>
            </h1>
            <section id="projecttext">
              <div>
                {/* <h2>[INFO]</h2> */}
                <p>
                  <br />
                  This project was born from a desire to make sense of the self
                  in the context of the present, and the strange pull of
                  recurring fragments. Pieces that seemed unrelated, yet over
                  time began to form a collection and suggest a deeper
                  structure. They weren’t events with obvious meaning, but
                  moments charged with something symbolic: hidden meanings,
                  visual repetitions, glitches, patterns, associations that
                  resisted logical explanation but felt impactful. What remains
                  is a photographic archive of these fragments: the overlooked,
                  the broken, the misplaced, the accidental accumulation of
                  symbolic debris, always present, rarely noticed.
                  <br /> At the core of this project is the lens through which
                  we’ve learned to see, think about, and share the world around
                  us. We don’t actually see the world as it is, we see it the
                  way it’s been shaped for us. Language, religion, science,
                  culture, and politics are the systems that quietly organize
                  not just how things work, but how we respond to them. Since,
                  we usually inherit them, rather than choose them, they often
                  remain invisible. <br />
                  This invisibility becomes visible when the system falters.
                  When a symbol appears out of context, when an object shows up
                  where it doesn’t belong, when you can’t find a logical
                  explanation right away. These moments are sacred not because
                  they promise revelation, but because they refuse definition.
                  This project proposes not just to describe but to notice, and
                  to recognize the rupture without rushing to repair it. <br />
                  The main three themes stood out from the fragments I
                  collected: <br />• The Organic <br />• The Symbolic <br />•
                  The Technological <br />
                  These are not fixed categories. They are overlapping modes of
                  organization, each producing its own form of meaning. What
                  links them is a recurring structure: they exist out of
                  context, break the expected, and are captured. This project
                  does not propose a system or a rulebook. It documents and
                  explores symbolic anomalies, how the organic, symbolic and
                  digital exists in the context of the present.
                  <br />
                  <span className="h2description">
                    {" "}
                    <br />
                    <br />
                    The Lens and the Rulebook
                    <br />
                    <br />{" "}
                  </span>
                  <p>
                    <br />
                    We created systems to help us understand the world.
                    Structures for describing, naming, interpreting what
                    surrounds us. Language, culture, science, religion, politics
                    operate not only as a means of communication or
                    coordination, but as a perceptual filter. They are lenses
                    through which the world becomes legible, and through which
                    meaning is assigned. These lenses shape not just what we
                    see, but what we believe is worth seeing at all.
                    <br />
                    Language is perhaps the most foundational of these
                    structures. It does not simply mirror the world, it frames
                    it. Words are not passive labels, they are symbols saturated
                    with inherited meaning. They structure how we think, how we
                    judge, how we remember. As language accumulates use, it
                    becomes a kind of rulebook, a system of constraints as much
                    as a system of communication. And each language, with its
                    own categories and rhythms, produces a different personality
                    of thought.
                    <br />
                    The linguist Ferdinand de Saussure described how language
                    works through a system of signs: each made of a signifier
                    (the form of a word, image, or sound) and a signified (the
                    idea or concept it points to). Most of the time, the link
                    between signifier and signified goes unnoticed. But when
                    that link breaks, when the image, phrase, or gesture doesn’t
                    line up with what we expect, it creates friction. A pause.
                    Like when a familiar word suddenly feels foreign, or when a
                    gesture means something different depending on who’s
                    watching. That friction is what pulls us into
                    interpretation. It’s what makes us reattach meaning where it
                    fell away.
                    <br />
                    Other systems operate in a similar way. Science measures and
                    explains. Religion binds moral meaning to narrative
                    structure. Cultural frameworks establish norms that are
                    rarely questioned. These systems are inherited, often
                    unconsciously, and over time they become indistinguishable
                    from the reality they were built to interpret. The rules
                    recede, and what remains is a conditioned way of seeing.
                    <br />
                    Nature, which we like to imagine as pure or chaotic, reveals
                    patterns when we study it: venation in leaves, Fibonacci
                    spirals in shells, the math behind water waves and sand
                    dunes. We find math in nature, write equations to simulate
                    it, and reproduce it in 3D environments, design software,
                    generative systems. In doing so, we don’t just observe
                    nature, we are able to simulate it using our own frameworks.
                    <br />
                    Every System we create reflects us back to ourselves. Within
                    this loop, we are never outside. We are both the observers
                    and the participants. The observer is never untouched. We
                    build systems, perform within them, and are shaped by them.
                    Even in documenting the anomaly, we become part of it. There
                    is no neutral gaze. Only perspective conditioned by
                    inherited systems. The act of seeing is itself structured.
                    <br />
                    The world is increasingly experienced as simulation, not
                    because it’s fake, but because it has been reformatted to
                    align with systems we already trust and are familiar with.
                    These systems give us clarity. But they also limit the
                    possibility of encountering something outside their logic.
                    This raises a deeper question: Can anything be perceived
                    outside the systems we’ve built to perceive it?
                    <br />
                    This chapter does not aim to resolve that question. Instead,
                    it opens the condition in which it arises. The symbolic is
                    not static. It shifts, cracks, and occasionally fails. The
                    moments where meaning appears unstable, or emerges
                    unexpectedly, are not breakdowns. They are points of contact
                    with something outside the expected. To navigate the present
                    we must see where these systems strain and overlap.
                    <br />
                    <br />
                    <span className="h2description">
                      {" "}
                      <br />
                      The Symbol and the Break <br />
                      <br />
                    </span>
                    <p>
                      <br />
                      The Symbol as currency:
                      <br />
                      <br />
                      In digital space, the meaning moves at the speed of
                      reaction. It circulates like currency: traded, amplified,
                      and converted into visibility. The symbol no longer points
                      to reality, it produces it. <br />
                      Social media, professional networks, dating profiles and
                      portfolios, are filled with constructs of selves as
                      composite signs. An assemblage of images, references,
                      tastes, and affiliations, all optimized for clarity,
                      recognition, and appeal. Style becomes signal, aesthetic
                      choices hint at values, cultural references sketch out
                      social position. A photograph doesn’t reveal identity, it
                      frames intention. It shows the version of self someone
                      wants you to read, or the version the photographer chooses
                      to capture. We navigate these symbols more than we
                      navigate the true self. This process is not limited to
                      appearance, it includes behavior, tone, language, and
                      background. It shapes not only how we express ourselves,
                      but how we understand who we are. Sense of self begins to
                      form from symbols we’ve seen, most of which are
                      simulations. No longer trying to be whole, but desperate
                      for legibility.
                      <br />
                      Inside this structure, the glitch becomes something
                      different from an error. It is the moment the loop breaks
                      open and meaning is no longer preassigned. Nothing is
                      being sold, nudged, or suggested. For a brief instant the
                      system stops translating the world for us, and
                      interpretation returns to the viewer. The glitch may be
                      accidental, but the freedom it creates is not.
                      <br />
                      This mirrors what cultural theorist Jean Baudrillard
                      called the shift from use value to sign value. A post
                      isn’t simply a record of something, it’s a symbol dropped
                      into a semiotic economy, where its meaning is shaped by
                      the symbols surrounding it. And in this system, machines
                      become the audience. The algorithm decides what gets seen,
                      what gets surfaced, and what becomes legible. We don’t ask
                      if it’s a true representation. We ask if it will be
                      recognized, read correctly, or relatable.
                      <br />
                      These kinds of symbols differ from the ones that break the
                      ordinary. These work as currency. The symbols circulating
                      socially and economically, like signals that represent
                      values, status, ideas and brands. A symbol, then, doesn’t
                      need truth. It only needs reception.
                      <br />
                      <br />
                      Cathedrals are everywhere for the eyes to see:
                      <br />
                      <br /> Symbols without origin become relics. They don’t
                      belong to any known narrative, yet they persist. In their
                      dislocation, they gain power. These moments don’t explain
                      themselves. They don’t ask to be believed. The moment it
                      sticks with us, and demands interpretation, or insists on
                      being noticed.
                      <br />
                      This is why the smallest event can feel like a sign:
                      <br />• A word overheard that seems perfectly timed.
                      <br />• A crow colliding with a window on in the middle of
                      the night.
                      <br />• The thought in your head that suddenly appears in
                      your recommended feed.
                      <br />• An odd object is floating in the sky.
                      <br />
                      We might call it coincidence, a glitch, a gut feeling. But
                      we don’t let it pass. We are wired to assign meaning, to
                      match the signifier with a signified, even when one
                      doesn’t exist, it isn’t irrational, it’s how perception
                      works. We see a pattern, and when that pattern breaks, our
                      instinct isn’t to dismiss it but to explain it, understand
                      it, recognize patterns, and get answers. We don’t ignore
                      anomalies, we narrate them. We manufacture symbols
                      constantly, sometimes without realizing it, because a
                      world without meaning would be unknown. And that unknown
                      can feel terrifying.
                      <br /> So the symbol isn’t in the thing, it’s in the whole
                      context. In the timing, the framing, the conditions that
                      make it stand out. It exists because of the structure, but
                      also outside it. Without a system to push against, there
                      is no unexpected at all.
                      <br />
                      But if everything can become symbolic, what happens to
                      meaning, does the concept flatten out?
                      <br />
                      Can we manufacture symbols, or do they only appear when
                      the system itself slips?
                      <br />
                      Are they all equally significant?
                      <br />
                      Does the moment only matter because we need it to?
                      <br />
                      <br />
                      This is where the painter René Magritte offers a warning:
                      “People who look for symbolic meanings fail to grasp the
                      inherent poetry and mystery of the image. No doubt they
                      sense this mystery, but they wish to get rid of it. They
                      are afraid. By asking what does this mean?’ they express a
                      wish that everything be understandable. But if one does
                      not reject the mystery, one has quite a different
                      response. One asks other things.” In other words: when we
                      try to pin the symbol down, we flatten it. We strip away
                      the tension that gave it weight. When we ask for answers,
                      we lose an opportunity to learn about ourselves. We ask
                      others to dictate how and why, so we can react to that
                      truth, instead of creating our own.
                      <br />
                      <span className="h2description">
                        {" "}
                        <br />
                        <br />
                        Machine Vision and the Human Lens
                        <br />
                        <br />{" "}
                      </span>
                      <p>
                        <br />
                        This effect is not limited to human systems.
                        Increasingly, we’ve extended our perceptual logic into
                        the machines we’ve built. Cameras and programs capture
                        and recognize contrast, edge, symmetry, faces, and
                        objects, our visual preferences encoded into technical
                        form. Machines are not made to see the world on their
                        own terms, they were made to capture what we see. But
                        machine sight doesn’t have to be visual. Some systems
                        can map environments using Wi-Fi signals, bouncing waves
                        through walls to track movement. Others use infrared,
                        LIDAR, or magnetic fields. These are not human senses,
                        they’re forms of sensing that create entirely different
                        images. That’s a different way of seeing, and a
                        different symbolic logic. Not shaped by eyes, but by
                        data unseen to us.
                        <br />
                        As Vilém Flusser writes, the camera is an apparatus, a
                        programmed system that predetermines what can be seen
                        and how it can be represented. The photographer becomes
                        its functionary, selecting within the limits of its
                        possibilities rather than freely expressing intent. The
                        machine extends perception while also scripting it,
                        producing what Flusser calls technical images, coded
                        information that both reveals and conceals the logic
                        behind it. These codes are structured by decisions made
                        long before the image appears: design choices,
                        institutional pressures, cultural biases. To look at
                        such an image is to confront not reality itself, but the
                        program that interprets it. We made machines resemble
                        us, not because it was the best way to do it, but
                        because we didn’t know how to do it any other way.
                        Uncanny robotic facial expressions, arms like ours but
                        are a struggle to operate, two legs that make it
                        challenging to stand or move, the wiring that resembles
                        our nervous systems, circuitry transmitting signals like
                        neurons firing across synapses, sensors act like eyes,
                        ears, and skin, extensions of human senses turned into
                        machines. Algorithms learn from data structured by human
                        decision making: what to highlight, what to suppress,
                        what counts as relevant. Machine intelligence mirrors
                        the structures we use to sort knowledge: hierarchies,
                        tags, categories, feedback loops. Visual recognition
                        tools are trained on datasets labeled and filtered by
                        human judgment. The ai companion models become portable
                        dictators of the manufactured truth. It can’t be honest,
                        as honesty can be offensive. it’s sole purpose is to be
                        likable, relatable, and agreeable. Most machines work
                        the way we do, not only to complete tasks, but to
                        perceive like us. This isn’t about tools that help us
                        daily, this is about machines built to inherit our
                        assumptions, the one’s we were born into. Artificial
                        Intelligence is a mirror that reflects human biases,
                        values, greed, consumption, priorities, and what we are
                        willing to trade for convenience. Here lies the paradox:
                        the machines were suggested to expand our perception,
                        but we constrained that perception from the start.
                        <br />
                        What would it take for a machine to see without us? To
                        develop a symbolic system not anchored in human
                        priorities or constraints?
                        <br />
                        This would require a form of untraining, an exit from
                        the human gaze. But even the idea of such a gaze is
                        difficult to imagine. We are so embedded in our own
                        symbolic structures that the possibility of a truly
                        foreign perception system feels either divine or
                        illegible.
                        <br />
                        <br />
                        <span className="h2description">
                          {" "}
                          <br />
                          Sacred Digital
                          <br />{" "}
                        </span>
                        <br />
                        <br />
                        The anomaly, as explored earlier, gains symbolic weight
                        by breaking the expected pattern. The rise of machine
                        vision and algorithmic perception has added a new layer
                        to the symbolic system. In the digital realm, the
                        anomaly is often a technical failure: corrupted files,
                        pixel shifts, algorithmic misfires. These are typically
                        dismissed as errors, because they break the rules we
                        gave them, yet in practice, they often function as
                        moments of strange beauty, humor, or unease. They feel
                        unscripted inside an environment built on control and
                        precision. What makes them compelling is not their
                        randomness, but their position within a structured,
                        rule-based system. It’s the bug that proves the code
                        exists.
                        <br />
                        This is where Baudrillard’s theory of simulacra enters
                        the conversation. In a reality shaped by signs referring
                        only to other signs, the glitch does not disrupt
                        reality, it disrupts the simulation, and a break in
                        seamless design becomes a flash of authenticity. These
                        moments are experienced as hyperreal: more real than
                        real. They offer friction, imperfection, or failure
                        within systems designed to be invisible. They become
                        reminders that there is still something outside the
                        loop.
                        <br />
                        Object-Oriented Ontology (OOO), introduced by thinkers
                        like Graham Harman, challenges the idea that objects
                        only matter when they're useful or visible to humans. In
                        OOO, everything, whether a rock, a machine, a glitch, or
                        a flame has its own kind of reality, independent of how
                        we encounter it. OOO provides a powerful lens. Rather
                        than seeing a glitch as an error, it suggests that it
                        might be a sign of the object’s own reality asserting
                        itself. That moment of breakdown isn’t just symbolic for
                        the viewer, it might be an expression of the object’s
                        autonomy, its refusal to be totally grasped or
                        contained.
                        <br />
                        When something stands out on a screen, it shouldn’t be
                        overlooked, because it is one of the few moments not
                        pre-shaped for us. It arrives unfiltered, without
                        instruction, and that is precisely what makes it worth
                        noticing.
                        <br />
                        <br />{" "}
                        <span className="h2description">
                          {" "}
                          <br />
                          The Simulated Self
                          <br />{" "}
                        </span>
                        <br />
                        <br />
                        Technology was first presented as liberation, a way to
                        move freely through endless possibility. But as the
                        logic of platforms evolved, the direction reversed.
                        Instead of seeking out what we want, we are told what we
                        should want, before we even decide for ourselves. This
                        is how the digital world became endless in quantity and
                        hollow in quality, a constant stream of content that
                        fills time without offering any weight. There is always
                        something new to consume, yet almost nothing to
                        interpret. The experience grows larger while the meaning
                        grows smaller.
                        <br />
                        If machines reflect us, and symbols emerge from context,
                        then our sense of identity, plays a big part in these
                        systems. We exist in relation to what we see, what we
                        signal, and how we are interpreted. And more than ever,
                        that interpretation is mediated through simulation.The
                        image of the self circulates before the self speaks.
                        Presence becomes secondary to profile, and we are no
                        longer simply perceived, we are formatted.
                        <br />
                        This is visible in subtle ways:
                        <br />• The way language trends alter how we process
                        emotion.
                        <br />• The way our sense of agency is filtered through
                        reaction and feedback.
                        <br />• The way authenticity becomes performance, and
                        validation becomes proof of presence.
                        <br />• The way silence online feels like absence
                        itself.
                        <br />
                        As Jean Baudrillard wrote in Simulacra and Simulation,
                        when simulation becomes dominant, the copy replaces the
                        original. Meaning starts to feed back on itself. The
                        system refers to its own signals, not to the world
                        outside.
                        <br />
                        This dynamic extends beyond personal identity. On
                        political stages, a rebel, an outsider, a voice against
                        the system, once picked up by media, becomes more than a
                        person. They become a symbol, a shorthand for resistance
                        or belief. Their actions matter less than the image they
                        project. We align with the version that resonates with
                        us symbolically, with that brand image. Political
                        affiliation today is often less about ideology and more
                        about symbolic alignment. A candidate becomes a
                        container of anger, hope, nostalgia, disruption. People
                        don’t just choose positions, they choose sides, myths,
                        aesthetics. Beliefs harden around the image, and
                        language follows. Symbolism, amplified by media and
                        repetition, takes hold faster than facts.
                        <br />
                        Roland Barthes, in Mythologies, showed how even the most
                        ordinary signs like images, objects, and gestures
                        operate as myths. Barthes argues that the most dangerous
                        aspect of myth is how it makes constructed meanings feel
                        real and natural. Everything can become myth: clothes,
                        art, products, glitches, even errors, all can carry
                        symbolic weight far beyond their function. This
                        saturation of meaning shapes perception before we even
                        notice.
                        <br />
                        We might try and locate ourselves within this symbolic
                        grid. So the question becomes: where do you fit in all
                        of this? And is that position chosen or performed?
                        <br />
                        Identity becomes an artifact. Every action is archived,
                        encoded, processed. We turn into symbolic beings inside
                        the machine’s archive. The symbolic system does not
                        simply reflect identity, it produces it. We are the
                        observer and the observed. Every gesture is made legible
                        not just to other people, but to the system itself. And
                        yet, meaning still leaks through. The symbolic isn’t
                        always intentional. Sometimes, it emerges by accident: a
                        badly cropped image, a typo, a misunderstanding or
                        misinterpreted message. A moment of silence that says
                        more than a statement. Which brings us back to the
                        earlier question: <br />
                        If the symbolic is context-based, emerging only through
                        contrast, rupture, and framing, and if our identities
                        are constructed, optimized, and looped through data and
                        signs, then what is left?
                        <br />
                        Is there a part of us that remains unsymbolized?
                        <br />
                        Or is identity itself now a form of data, arranged,
                        optimized, and replayed until the simulation becomes
                        indistinguishable from the self?
                        <br />
                        The symbolic self isn’t new. It has always existed in
                        ritual, myth, and performance. But the scale and speed
                        of simulation today is different. There is no longer
                        time for interpretation, only recognition. Meaning
                        happens instantly, or not at all. And sometimes, we
                        forget to notice what’s beneath. If there's anything
                        beneath.
                        <br /> <br />{" "}
                        <span className="h2description">
                          {" "}
                          <br />
                          Toward a New Lens
                          <br />{" "}
                        </span>
                        <br />
                        <br />
                        To ask if something can exist outside human-made systems
                        is to ask from inside those systems.
                        <br />
                        This is the paradox. We search for a perspective beyond
                        the lens, but the act of searching is already
                        conditioned by the very frameworks we want to escape.
                        Language, identity, technology, symbol, they are not
                        outside of us. They are the architecture through which
                        we experience anything at all.
                        <br />
                        Different systems were made to make sense of the world.
                        And over time, we began to mistake those systems for the
                        world itself.
                        <br />
                        We recreated natural processes through math and code,
                        turned feeling into narrative, mapped value onto
                        objects, trained machines to see, using our own
                        perceptual defaults. And now, we are surrounded by
                        mirrors, some human, some artificial, and they reflect
                        those decisions back to us. Meaning becomes less about
                        what is and more about what fits. What can be
                        understood, named, classified. The unknown becomes
                        uncomfortable not because it’s dangerous, but because it
                        is not understood.
                        <br />
                        In every glitch, there is a flicker of unscripted
                        reality; in every symbolic rupture, a trace of something
                        unframed. Moments that resist explanation but leave a
                        distinct impression remind us that not all meaning is
                        constructed. Those are the areas where the code becomes
                        visible, where perception stutters, where symbolic logic
                        collapses just enough to make room for something else.
                        We can learn to notice it, recognize when we are
                        interpreting, performing, assuming, projecting, and to
                        pause when meaning arrives too easily. This is not about
                        finding a final answer, but about refining the act of
                        observation. A new lens does not reveal a new world, it
                        allows us to see the same world differently. <br /> And
                        sometimes, that is enough.
                        <br />
                        <br />
                        <span className="h2description">
                          {" "}
                          <br />
                          Sources & References
                          <br />{" "}
                        </span>
                        <br />
                        <br />
                        Baudrillard, Jean. Simulacra and Simulation.
                        Semiotext(e), 1981.
                        <br />
                        Barthes, Roland. Mythologies. Seuil, 1957.
                        <br />
                        Benjamin, Walter. The Work of Art in the Age of
                        Mechanical Reproduction. 1935.
                        <br />
                        Flusser, Vilém. Towards a Philosophy of Photography.
                        Reaktion Books, 1983.
                        <br />
                        Harman, Graham. Object-Oriented Ontology: A New Theory
                        of Everything. Pelican Books, 2018.
                        <br />
                        Haraway, Donna. A Cyborg Manifesto: Science, Technology,
                        and Socialist-Feminism in the Late Twentieth Century.
                        Routledge, 1985.
                        <br />
                        Magritte, René. Selected Writings. University of
                        Minnesota Press, 2016.
                        <br />
                        Saussure, Ferdinand de. Course in General Linguistics.
                        McGraw-Hill, 1916.
                        <br />
                        <br />
                        <br />
                        <br />
                      </p>
                      <br />
                    </p>
                  </p>
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Project4;
